import React, { useState, useEffect } from 'react';

import { modalStyle1024 } from '../../shared/commonStyle';

import { r2_updateData, r2_CheckCabinet, r2_unfilteredList } from '../../../Helpers/r2_requests';

import Upload from '../../Upload/Upload';
import ViewUploads from '../../Upload/ViewUploads';

import { APIROOT } from '../../../Helpers/configs';

import { defineTicketNumber } from '../../../Helpers/helpers';

import InstallTicketCustomer from './InstallTicketCustomer';
import InstallTicketTransport from './InstallTicketTransport';
import InstallTicketCabinet from './InstallTicketCabinetV2';
import InstallTicketType from './InstallTicketType';
import InstallTicketProcess from './InstallTicketProcess';

import { useLocation, useNavigate } from 'react-router-dom';

import { GetAuth } from '../../../Auth/AuthProvider';

import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Divider,
  Modal,
} from '@mui/material';
import { AddToPhotosOutlined as AddMoreIcon, Today } from '@mui/icons-material';

import { ticketTypoTitle, ticketTypoInfo } from '../../shared/commonStyle';

import { INSTALL_TICKETTYPES } from '../../shared/CONSTANTS';

import UnauthorisedAccess from '../../CommonComponents/UnauthorisedAccess';

const InstallTicketAddEdit = (props) => {
  const INSTALL_TICKETTYPESLIST = [...INSTALL_TICKETTYPES];
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleViewOpen = () => setViewOpen(true);
  const handleViewClose = () => setViewOpen(false);

  const location = useLocation();
  const ticketData = location.state;
  const navigateBack = useNavigate();

  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [cancelReason, setCancelReason] = useState(null);

  const [active, setactive] = useState(ticketData.active);

  const [useType, setUseType] = useState(localStorage.getItem('type'));

  const [ticketStatus, setTicketStatus] = useState(ticketData.status);

  const [customerName, setCustomerName] = useState(ticketData.customer_name);
  const [customerInfo, setCustomerInfo] = useState({
    category: ticketData.customer_category_name,
    category_guid: ticketData?.customer_category_guid,
    storeName: ticketData.customer_name,
    customerId: ticketData.customer_id,
    address: ticketData.customer_address,
    branchCode: ticketData.customer_branchcode,
    contactPerson: ticketData.customer_contact_name,
    contactNumber: ticketData.customer_contact_number,
    assetComp: ticketData.customer_asset_comp_name,
    capexNr: ticketData.capex_number,
    dnNr: ticketData.dn_number,
    notify: ticketData.notify_customer,
    loggedBy: ticketData.creator_name,
    loggedByNumber: ticketData.creator_number,
    transporter: ticketData.transporter,
    date_scheduled: ticketData.date_scheduled,
  });

  const [description, setDescription] = useState(ticketData.description);



  //Cast old cabinet data before saving it - this can be removed after data is sanitized / reloaded
  const ConvertLegacyCabinets = (list) => {
    let tempList = list;

    for(let i = 0; i < tempList.length; i++)
    {
      if(typeof tempList[i].cabEntry === 'undefined')
      {
        tempList[i].cabEntry = {
          id: tempList[i].cabId,
          name: tempList[i].cabType
        };
        tempList[i].validationError = null;
      }
    }

    return tempList;
  };
  const [serialListV2, setSerialListV2] = useState(ConvertLegacyCabinets(ticketData.serial_numbers));
  
  const [cabList, setCabList] = useState([]); 

  useEffect(() => {
    r2_unfilteredList(
      {
        resource: `/api/warranties`,
        setDataFunc: setCabList,
        showNotification: enqNotification,
        logout,
        payloadBlob: {
          pagereq: {},
        },
      },
      'install-tickets'
    );
  }, [enqNotification, logout]);


  const updateSerialWithCallback = (index, callbackfunc) => {
    setSerialListV2((currentList) => {
      let tempList = currentList;
      tempList[index] = callbackfunc(tempList[index]);

      return tempList;
    });
    setForceUpdate(i => i + 1);
  }


  const addSerialV2 = (item) => {
    //Add entry to cabinet list
    setSerialListV2((currentList) => {
      let tempList = currentList;
      tempList.push(item);
      return tempList;
    });
    setForceUpdate(i => i + 1);
}

const deleteSerialV2 = (index) => {
  setSerialListV2((currentList) => {
    let tempList = currentList;
    tempList.splice(index, 1);
    return tempList;
  });
  setForceUpdate(i => i + 1);
}

  const [ticketTypeData, setTicketTypeData] = useState({
    ticketType: INSTALL_TICKETTYPESLIST.filter(
      (item) => item.name === ticketData.ticket_type
    )[0],
    // ticketData.ticket_type === 'install'
    //   ? { id: '1', name: 'install' }
    //   : { id: '2', name: 'upliftment' },
    techAssigned: {
      id: ticketData.tech_assigned,
      name: ticketData.tech_assigned_name,
    },
    assistantTech: {
      id: ticketData.assist_tech_assigned,
      name: ticketData.assist_tech_assigned_name,
    },
    subbieAssigned: {
      id: ticketData.sub_assigned,
      name: ticketData.sub_assigned_name,
    },
    subbieContactNr: ticketData.sub_contact,
    purchaseOrder: ticketData.sub_customer, //Note: sub_customer was not changed to purchase_order because we didn't change to column in the database.
  });

  const handlechange = (event) => {
    switch (event.target.id) {
      case 'description':
        setDescription(event.target.value);
        break;
      default:
        break;
    }
  };

  const checkTechAssigned = () => {

    const status = ticketData.status.toLowerCase();

    if(status === 'new' || status === 'logged' || status === 'assigned'){
      return ticketTypeData.techAssigned.id === null && ticketTypeData.subbieAssigned.id === null ? 'logged' : 'assigned';
    }

    return ticketData.status; 
  };

  const combineData = () => {

    let ticketBlob = {
      install_ticket: {
        ticket_type: ticketTypeData.ticketType.name,
        status: checkTechAssigned(),
        description: description,
        serial_numbers: serialListV2,
        customer_id: customerInfo.customerId,
        customer_contact_name: customerInfo.contactPerson,
        customer_contact_number: customerInfo.contactNumber,
        notify_customer: customerInfo.notify,
        capex_number: customerInfo.capexNr,
        dn_number: customerInfo.dnNr,
        transporter: customerInfo.transporter,
        date_scheduled: customerInfo.date_scheduled,
        tech_assigned:
          ticketTypeData.techAssigned.id === null
            ? null
            : ticketTypeData.techAssigned.id,
        assist_tech_assigned:
          ticketTypeData.assistantTech.id === null
            ? null
            : ticketTypeData.assistantTech.id,
        sub_assigned:
          ticketTypeData.subbieAssigned.id === null
            ? null
            : ticketTypeData.subbieAssigned.id,
        sub_contact:
          ticketData.subbieContactNr === null
            ? undefined
            : ticketTypeData.subbieContactNr === null
            ? ''
            : ticketTypeData.subbieContactNr,
        sub_customer:
          ticketTypeData.purchaseOrder === null ? '' : ticketTypeData.purchaseOrder,
        active: active,
        cancel_reason: '',
      },
    };

    return ticketBlob;
  };
  const cancelTicket = () => {
    let cancelBlob = {
      install_ticket: {
        ticket_type: ticketTypeData.ticketType.name,
        customer_id: customerInfo.customerId,
        status: 'canceled',
        cancel_reason: cancelReason,
      },
    };
    return cancelBlob;
  };

  const cancelSave = () =>
    navigateBack(`/ticket`, {
      replace: true,
      state: 'install',
    });

  const ticketUpdate = () => {
    const nodePath =
      ticketStatus === 'new'
        ? '/r2_install_tickets'
        : `/r2_install_tickets/${ticketData.id}`;
    const cancelTrue =
      cancelReason === null ? false : cancelReason.length < 5 ? false : true;
    const dataBlob =
      // { ...combineData() };
      cancelTrue ? { ...cancelTicket() } : { ...combineData() };

    const path = '/ticket';
    const uri = nodePath;
    r2_updateData({
      uri: uri,
      dataBlob: dataBlob,
      cancelEdit: () => {},
      setForceUpdate,
      navigateBack,
      path: path,
      logout: logout,
      enqNotification: enqNotification,
      updateMessage: 'install ticket updated',
      type: 'install ticket',
      state: 'install',
    });
    // console.log('running');
  };

  const [ticketDataReq, setTicketDataReq] = useState({});

  useEffect(() => {
    getTicketDatabyId(location.state.id).then((data) => {
      setTicketDataReq(data.data.value);
      // console.log(data.data.value);
    });
  }, [location.state]);

  
  const serialErrorsPresent = () => {
    let returnvalue = false;
    for(let i = 0; i < serialListV2.length; i++)
    {
      if(serialListV2[i].validationError !== null)
      {
        returnvalue = true;
      }
    }

    return returnvalue;
  }


  return useType === 'technician' ? (
    <UnauthorisedAccess />
  ) :  (
    <Box
      style={{
        minHeight: '20vh',
        maxWidth: '100%',
        textAlign: 'left',
        border: 'solid 2px #354775',
        background: '#ebedf8',
        borderRadius: '5px',
      }}
    >
      <Typography
        style={{
          background: '#354775',
          padding: '15px',
          border: 'solid 2px #354775',
          color: '#ffffff',
        }}
        variant='h5'
      >
        TICKET NR:{' '}
        {ticketData.id === null
          ? 'New Ticket'
          : defineTicketNumber(ticketData.ticket_type, ticketData.id, '5', 'I')}
      </Typography>
      <Box
        name='customerDetails'
        style={{
          minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Grid container sx={{ marginTop: '15px' }}>
          <Grid item xs={12} lg={8}>
            <InstallTicketCustomer
              ticketId={ticketData.id}
              customerInfo={customerInfo}
              onNameChange={(name) => setCustomerName(name)}
              onCustomerInfoChange={(eventTarget, eventValue) => {
                setCustomerInfo({ ...customerInfo, [eventTarget]: eventValue });
              }
            }
            onCustomerInfoChangeV2={(key, value) => {
              setCustomerInfo((currentEntry) => {
                let tempCurrent = currentEntry;
                if(typeof key === 'object' && typeof value === 'object')
                {
                  for(let i = 0; i < key.length; i++)
                  {
                    tempCurrent = {...tempCurrent, [key[i]] : value[i]}
                  }
                }
                else
                {
                  tempCurrent = {...tempCurrent, [key] : value}
                }
                return tempCurrent;
              });
            }}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <InstallTicketTransport
              transporter={customerInfo.transporter}
              date_scheduled={customerInfo.date_scheduled}
              onCustomerInfoChange={(eventTarget, eventValue) => {
                setCustomerInfo({ ...customerInfo, [eventTarget]: eventValue });
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Divider />

      <Box
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Grid container sx={{ marginTop: '15px' }}>
          <Grid item xs={12} lg={1.2}>
            <Typography style={ticketTypoTitle}>Description:</Typography>
          </Grid>
          <Grid item xs={12} lg={10.3}>
            <TextField
              size='small'
              sx={{
                width: '100%',
                background: '#ffffff',
                padding: 0,
              }}
              required
              id='description'
              defaultValue={description}
              onChange={handlechange}
            />
          </Grid>
          <Grid item xs={12} lg={1.2}>
            <Button
              onClick={() => {
                 setForceUpdate(i => i + 1);
                 addSerialV2({
                  cabEntry : null,
                  cabId : null,
                  cabType : null,
                  serialNo : '',
                  serialChecked: true,
                  warranteePeriod : 0,
                  validationError: null
                });
              }}
              startIcon={<AddMoreIcon />}
              label='Add'
            >
              Add
            </Button>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Typography variant='h6'>Logged Cabinets:</Typography>{' '}
            {/* {console.log(customerInfo.storeName)} */}
          </Grid>
          <Grid item xs={12} lg={12}>
            <InstallTicketCabinet
              customerCategory={customerInfo.category_guid}
              serialsDataList={serialListV2}
              addSerial={addSerialV2}
              deleteSerial={deleteSerialV2}
              cabinetTypeList={cabList}
              updateSerialWithCallback={updateSerialWithCallback}
            />
          </Grid>
        </Grid>
      </Box>
      <Divider style={{ marginBottom: '15px' }} />
      <Box
        name='ticketDetails'
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <InstallTicketType
          ticketTypeData={ticketTypeData}
          ticketStatus={ticketStatus}
          onTicketTypeDataChange={(eventTarget, eventValue) => {
            setTicketTypeData({ ...ticketTypeData, [eventTarget]: eventValue });
          }}
        />
      </Box>
      <Divider />
      <InstallTicketProcess
        validationErrorPresent={serialErrorsPresent()}
        ticketStatus={ticketStatus}
        cancelSave={cancelSave}
        handleOpen={handleOpen}
        handleOpenView={handleViewOpen}
        setCancel={() => {}}
        // cancelReason={cancelReason}
        ticketData={ticketData}
        cancelReason={(value) => setCancelReason(value)}
        onSave={() => {
          ticketUpdate();
        }}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle1024}>
          <Upload relationId={ticketData.id} relationType='installTickets' />
        </Box>
      </Modal>
      <Modal
        open={viewOpen}
        onClose={handleViewClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle1024}>
          <ViewUploads
            relationId={ticketData.id}
            relationType='installTickets'
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default InstallTicketAddEdit;


//TICKET DATA
async function getTicketDatabyId(TicketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {};

  const request = new Request(`${APIROOT}/api/install-tickets/${TicketId}`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}
